<div class="notify-template-preview-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'notifyTemplates.templatePreview'|translate}}</h2>
        <span class="template-id">{{data?.template?.TemplateId}}</span>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="preview" [ngTemplateOutletContext]="{ template: data.template }"></ng-container>
    </mat-dialog-content>
</div>

<ng-template #preview let-template="template">
    <upsc-notify-template-preview [template]="template"></upsc-notify-template-preview>
</ng-template>